import { FC } from 'react';
import { Input, Typography } from 'antd';

import s from './index.module.scss';

type SettingsDisabledInputProps = {
	className?: string;
	name?: string;
	value?: string;
	options?: {label: string; value: string | number}[];
};

export const SettingsDisabledInput: FC<SettingsDisabledInputProps> = ({
	className,
	name,
	value,
	options = [],
}) => {
	const val = options?.length > 0
		? options.find((v) => v.value == value)?.label
		: value;
	return (
		<div className={className}>
			<Typography.Text className={s.text}>{name}</Typography.Text>
			<Input className={s.input} disabled value={val} />
		</div>
	);
};
